/**
 * Centralized route path constants.
 * Avoid magic strings in routing configuration.
 */

// ─── User Routes ────────
export const USER_ROUTES = {
  LOGIN: '/login',
  HOME: '/',
  DASHBOARD: '/dashboard',
  SEARCH_RESULTS: '/search-results',
  PROFILE: '/profile',
  HISTORY: '/history',
  SUPPORT: '/support',
  TICKET_DETAIL: '/support/tickets/:id',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
};

// ─── Admin Routes ───────
export const ADMIN_ROUTES = {
  LOGIN: '/admin/login',
  DASHBOARD: '/admin/dashboard',
  TICKETS: '/admin/tickets',
  TICKET_DETAIL: '/admin/tickets/:id',
  USERS: '/admin/users',
  ASSIGN: '/admin/assign',
  EMPLOYEES: '/admin/employees',
};
